import { defaults, Line, Bar, Doughnut } from 'react-chartjs-2';
import React, { useEffect } from 'react';
import { fontString } from 'chart.js/helpers';
import { ContactlessTwoTone } from '@material-ui/icons';

export const ajeitaLegenda = {
  beforeInit: (chart) => {
    const orig = chart.legend.fit
    console.log(chart.legend)
    chart.legend.fit = function() { 
      orig.bind(chart.legend)()
      this.height += 30
     }
  }
}
export function prettyTime(secs) {  
    var s = Math.floor(secs % 60)
    var m = Math.floor(secs / 60) % 60
    var h = Math.floor(secs / 3600)
    return ((h < 10) ? "0" + h : "" + h) + ":" + ((m < 10) ? "0" + m : "" + m) + ":" + ((s < 10) ? "0" + s : "" + s)
  }
  
  const options = {
  plugins: {
    tooltip: {
      mode: 'index',
      callbacks: {
        label: function(context) {
          var label = context.dataset.label || '';
          const value = context.parsed.y

          if(label == 'Taxa de abandono'){
            label += ': ' + value.toFixed(1).replace('.',',') + '%'
          }else if(value !== null){
            label += ': ' + prettyTime(context.parsed.y);
          }
          
          return label;
        }
      }
    }
  },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        position: 'left',
        scalePositionLeft:false,
        type:'linear',      
      },
      y1: {
          id: 'y1',
          position: 'right',
          scalePositionLeft:false,
          type:'linear',
          ticks:{
            callback:function(value){
              return value + ' %'
            }
          }
        },    
    },
  };
  
  
  const colors = [
    "#93c2f1", // azul claro
    "#36494e", // azul 1
    "#eee1b3", // amarelo
    "#b4869f", // rosa
    "#597081", // azul 2
    "#c6dea6", // verde claro
    "#ced097", // bege
    "#149911", // verde
    "#a52740", // vinho
    "#ED6A5A"  // salmão
  ]
  
export function dateISOtoddmmyyyy(d){
  var ymd = d.split('-')
  return ymd[2] + '/' + ymd[1]// + '/' + ymd[0]
}

function setColor(obj,color){
  obj.backgroundColor = color
  obj.borderColor = color
}


export function renderGrafico(tipo,da,intervalo){
    if(da == null)
      return <></>
    if(tipo == 'volAtdGeral'){
      var data = {labels:da.datas,datasets:[
        {label:'Atendidas (ativas + receptivas)',data:da.ReceptivaAtendida.map((v,i)=>v + da.AtivaAtendida[i])},
        {label:'Ativas atendidas',data:da.AtivaAtendida},
        {label:'Receptivas atendidas',data:da.ReceptivaAtendida},
        {label:'Receptivas abandonadas',data:da.ReceptivaAbandonada},
        {label:'Taxa de abandono',data:da.TaxaAbandono,yAxisID:'y1'}
      ]}
      if(da.datas[0] && typeof da.datas[0] != 'number'){
        data.labels = da.datas.map(dateISOtoddmmyyyy)
      }else{
        data.labels = da.datas.map((d)=> (d < 10 ? '0'+d : d)+':00' )
      }
      setColor(data.datasets[0],colors[1])
      setColor(data.datasets[1],colors[0])
      setColor(data.datasets[2],colors[7])
      setColor(data.datasets[3],colors[6])
      setColor(data.datasets[4],colors[8])
  
      return <Line data={data} 
        options={options}
        plugins={[ajeitaLegenda]}
       />    
    }else if(tipo == 'volAtdUsuario'){
      var data = {labels:da.nomes,datasets:[
        {label: "Chamadas receptivas", data:da.rtv},
        {label: "Chamadas ativas", data:da.atv},
      ]}
      setColor(data.datasets[0],colors[0])
      setColor(data.datasets[1],colors[5])
      return <Bar data={data} 
        options={{
          responsive: true,
          maintainAspectRatio: false,
          animation:{
            onProgress:function() {              
              var chartInstance = this
              var ctx = this.ctx
      
              ctx.font = fontString(defaults.font.size * 0.7, defaults.font.style, defaults.font.family);
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
      
              var d = []
              var total = 0
              var min = (a,b) => a < b ? a : b
              this.data.datasets.forEach(function(dataset, i) {
                var meta = chartInstance.getDatasetMeta(i);              
                meta.data.forEach(function(bar, index) {                
                  var data = dataset.data[index];
                  d[index] = (d[index]) ? d[index] : {}
  
                  d[index].x = bar.x                
                  d[index].y = d[index].y ? min(d[index].y,bar.y) : bar.y
                  
                  d[index].sum = d[index].sum ? d[index].sum : 0
                  d[index].sum += data*1
  
                  total += data*1
                });
              });
              for (const item of d) {
                ctx.fillText(((item.sum / total)*100).toFixed(1).replace('.',',') + "%", item.x, item.y - 5);
              }
            }
          },
          plugins:{
            legend:{
              labels:{
                font:{size:18}
              }
            },
          },
          scales:{
            x:{
              stacked: true,
              ticks: {font:{size:18}}
            },
            y:{
              stacked:true,
              ticks: {font:{size:18}}
            }
          }
        }}
       />
    }else if(tipo == 'tiposPausa'){
      var data = {labels:da.tipos,datasets:[
          {data: da.duracao,backgroundColor:colors}
      ]}
      if(da.duracao == undefined)
        return <div></div>
      var total = da.duracao.reduce((a,b)=>a+b,0)
      return <div style={{height:'70vh'}}><Doughnut data={data} 
        options={{
          responsive:true,
          maintainAspectRatio: false,
          plugins:{
            tooltip:{
              callbacks:{
                label:function(ctx){
                  return ctx.label + ': '+(ctx.raw/total*100).toFixed(1).replace('.',',')+'%'
                }
              }
            }
          }
        }}
       /></div>
    }else if(tipo == 'tempoMedio'){      
      var data = {labels:da.datas,datasets:[
        {label:'Tempo médio de espera',data:da.tme},
        {label:'Tempo médio de atendimento',data:da.tma},
      ]}
      if(da.datas[0] && typeof da.datas[0] != 'number'){
        data.labels = da.datas.map(dateISOtoddmmyyyy)
      }else{
        data.labels = da.datas.map((d)=> (d < 10 ? '0'+d : d)+':00' )
      }
      setColor(data.datasets[0],colors[8])
      setColor(data.datasets[1],colors[0])    
  
      return <Line data={data} 
        options={
          {
            plugins:{
              tooltip:{
                callbacks:{
                  label:function(ctx){
                    return ctx.label + ': ' + prettyTime(ctx.raw)
                  }
                }
              }
            },
            responsive: true,
            maintainAspectRatio: false, 
            scales:{
              y:{
                id: 'y',
                position: 'left',
                scalePositionLeft:false,
                type:'linear',
                ticks:{
                  callback:function(value){
                    return prettyTime(value)
                  }
                }
              },          
            }
          }
        }
        plugins={[ajeitaLegenda]}

       />    
    }
  }